export const removeUnusedPropsFromStyledInput = {
    shouldForwardProp: (prop: unknown) =>
        !["setError", "setTouched", "maxWidth", "withoutBorder", "withoutErrorPlaceholder"].includes(prop as string),
};
